import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';

const ProductGalleryPage = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin
    if (!user || !user.is_admin) {
      navigate('/');
      return;
    }

    // Fetch images from API
    const fetchImages = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${API}/api/admin/cloudinary-images`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setImages(data.images || []);
        }
      } catch (error) {
        console.error('Failed to fetch images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [user, token, navigate]);

  if (!user || !user.is_admin) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-2">Product Images Gallery</h1>
        <p className="text-gray-600 mb-6">
          Admin only - {images.length} images in Cloudinary. Use these URLs when adding products.
        </p>
        
        {loading ? (
          <div className="text-center py-12">Loading images...</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {images.map((img, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-2">
                <img 
                  src={img.url} 
                  alt={`Product ${index + 1}`}
                  className="w-full h-32 object-cover rounded mb-2"
                />
                <p className="text-xs text-gray-500 truncate">#{index + 1}</p>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(img.url);
                    alert('URL copied!');
                  }}
                  className="w-full text-xs bg-black text-white py-1 rounded mt-1 hover:bg-gray-800"
                >
                  Copy URL
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductGalleryPage;
